/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Store_SoonInputs */

const en_portal_store_soon = /** @type {(inputs: Portal_Store_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming to`)
};

const pl_portal_store_soon = /** @type {(inputs: Portal_Store_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wkrótce w`)
};

/**
* | output |
* | --- |
* | "Coming to" |
*
* @param {Portal_Store_SoonInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_store_soon = /** @type {((inputs?: Portal_Store_SoonInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Store_SoonInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_store_soon(inputs)
	return en_portal_store_soon(inputs)
});